import { lazy } from 'react';

const DefaultRoute = '/';

// By default all routes except /login require authentication unless property public = true
const Routes = [
  {
    path: '/',
    component: lazy(() => import('../../views/Home')),
    public: true,
  },
];

export { DefaultRoute, Routes };
